<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "Cdf"
    }
</script>

<style scoped>

</style>